// extracted by mini-css-extract-plugin
module.exports = {"previewimg":"previewImage_previewimg_qXRIg","box":"previewImage_box_3XCk5","item":"previewImage_item_1CMgf"};